module.exports = __webpack_public_path__ + "static/media/red-dot.c4680e27.svg";